function customTextAnswers(state = {}, action) {
  switch (action.type) {
    case 'CUSTOM_TEXT_CHANGED' : {
      const newState = { ...state };

      const answer = {
        text: action.value,
        check: action.value.length === 0,
        questionId: action.questionId
      };

      if (!newState[action.evalId]) {
        newState[action.evalId] = {
          [action.questionId]: answer
        };
      } else {
        newState[action.evalId][action.questionId] = answer;
      };

      return newState;
    }
    case 'CUSTOM_TEXT_CHECKBOX_CHANGED' : {
      const newState = { ...state };

      const answer = {
        text: ``,
        check: !!action.value,
        questionId: action.questionId
      };

      if (!newState[action.evalId]) {
        newState[action.evalId] = {
          [action.questionId]: answer
        };
      } else {
        newState[action.evalId][action.questionId] = answer;
      };

      return newState;
    }
    case 'DATA_RECEIVED' : {
      const answers = action.data.customTextAnswers;
      return answers
        .map(answer => ({
          [answer.whom]: {
            [answer.question_id]: {
              text: answer.value,
              check: answer.skipped,
              questionId: answer.question_id,
              evalId: answer.whom
            }
          }
        }))
        .reduce((accumulator, currentValue) => {
          const keys = Object.keys(currentValue);

          if (!keys[0]) {
            return accumulator;
          }

          const value = accumulator[keys[0]] ? { ...accumulator[keys[0]], ...currentValue[keys[0]] } : currentValue[keys[0]];

          return { ...accumulator, [keys[0]]: value }
        }, {});
    }
    default:
      return state;
  }
}

export default customTextAnswers;
